(function () {
    'use strict';

    angular
        .module('FormBuilder')
        .factory('FormBuilderService', FormBuilderService);

    function FormBuilderService(lodash, FormBuilderState, FormEvents, FormElements, $timeout) {
        var mem = {},
            mainCtrlScope = null; // eslint-disable-line no-unused-vars

        return {
            initApp: initApp,
            init: init,
            sync: sync,
            get: get,
            getModel: getModel,
            destroy: destroy,
            rerender: rerender,
            hasDirtyForm: hasDirtyForm,
            getAll: function() { return mem; },
        };

        function initApp(scope) {
            mainCtrlScope = scope;
        }

        function init(form_name, ref, scope) {
            lodash.set(mem, form_name, ref);
            mem[form_name].currentScope = scope;
            mem[form_name].modelService = new FormBuilderState(mem[form_name].model);
            mem[form_name].elementsService = new FormElements(mem[form_name]);
            mem[form_name].eventsService = new FormEvents(mem[form_name]);
            return mem[form_name];
        }

        function sync(form_name, ref) {
            lodash.set(ref, 'pageData', lodash.get(mem, form_name, {}));
        }

        function get(form_name) {
            return lodash.get(mem, form_name, {});
        }

        function destroy(form_name) {
            mem = lodash.omit(mem, [form_name]);
        }

        function getModel(form_name) {
            return lodash.get(mem, form_name + '.model', {});
        }

        function hasDirtyForm() {
            return lodash.values(mem).reduce((results, current) => {
                if (results) return results; // if result is true, just continue. No need to check anymore
                if (!lodash.has(current.fbData, 'settings.check_for_dirty') || !current.fbData.settings.check_for_dirty) return results; // if form says don't check for data, then don't. Continue;
                return current.currentScope.form.$dirty; // Otherwise, set "results" as current form.$dirty;
            }, false);
        }

        function rerender(form_name) {
            console.log('rerender', mem[form_name].elements);
            $timeout(function() {
                var elements = mem[form_name].elementsService.getRenderedElements();
                angular.forEach(elements, function(element) {
                    if (lodash.has(element, 'render') && typeof element.render === typeof function() {}) {
                        element.render();
                    }
                });
            });
        }
    }
})();